import styled from 'styled-components'

export const BadgeContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;

  margin-top: 16px;

  svg {
    font-size: 64px;
  }
`

export const BadgeTitle = styled.h2`
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
`

export const BadgeForm = styled.form`
  display: flex;
  align-items: center;
  gap: 8px;
`
